import { httpClient } from "../http/httpClient";
import { PartnerType } from "@/app/utils/partners.enum";

export type GetAuthorizationIdParams = {
  type: PartnerType;
};

export type GetAuthorizationIdResponse = {
  _id: string;
  seller: {
    _id: string;
    name: string;
  };
  customer: {
    _id: string;
    name: string;
    cpf: string;
  };
  status: "PENDING" | "AUTHORIZED" | "NO_OFFER";
  type?: PartnerType;
  authorizationLink: string;
  linkExpirationDate: string;
  observation?: string;
  createdAt: string;
  updatedAt: string;
};

export const getAuthorizationId = async (
  id: string,
  params: GetAuthorizationIdParams,
) => {
  const { data } = await httpClient.get<GetAuthorizationIdResponse>(
    `/pre-transaction/${id}`,
    { params },
  );

  return data;
};
